module.exports = __webpack_public_path__ + "img/flower-relationship.a0286512.svg";